import { snoonuTheme } from './snoonu';

/**
 * Theme registry for client/organization-branded interview experiences.
 * Each theme declares a `matches(haystack)` predicate that receives a
 * lowercased string built from the canvass's organization name, display
 * name, and owner id. The first matching theme wins; otherwise the
 * default August Says theme is used.
 */
export const themes = [snoonuTheme];

export const defaultTheme = {
  key: 'default',
  matches: () => false,
  cssVars: {},
  logo: null,
  headerTagline: 'The Bots Experience',
  tracker: null,
  bot: null,
  footer: 'August Says · The Bots Experience · Beep greets, Boop listens, Bop delivers',
};

/**
 * Resolve the theme for a canvass from its status payload.
 * @param {Object} canvassData - Canvass status object (ownerId, displayName, companyContext)
 * @returns {Object} Theme config
 */
export const resolveTheme = (canvassData = {}) => {
  const orgName = canvassData?.companyContext?.name || canvassData?.displayName || '';
  const ownerId = canvassData?.ownerId || '';
  const haystack = `${orgName} ${ownerId}`.toLowerCase();
  return themes.find((t) => t.matches(haystack)) || defaultTheme;
};
